"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SideNav = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactResponsive = _interopRequireDefault(require("react-responsive"));

var R = _interopRequireWildcard(require("ramda"));

var _Icons = require("./Icons");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var SideNav =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SideNav, _React$Component);

  function SideNav() {
    _classCallCheck(this, SideNav);

    return _possibleConstructorReturn(this, _getPrototypeOf(SideNav).apply(this, arguments));
  }

  _createClass(SideNav, [{
    key: "render",
    value: function render() {
      var _this = this;

      return _react.default.createElement(_reactResponsive.default, {
        maxWidth: 1224
      }, function (matches) {
        return _react.default.createElement(SideNavP, _extends({
          matches: matches
        }, _this.props), _this.props.children);
      });
    }
  }]);

  return SideNav;
}(_react.default.Component);

exports.SideNav = SideNav;

var SideNavP =
/*#__PURE__*/
function (_React$Component2) {
  _inherits(SideNavP, _React$Component2);

  function SideNavP(props) {
    var _this2;

    _classCallCheck(this, SideNavP);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(SideNavP).call(this, props));
    _this2.state = {
      sideNavPreviousState: _this2.props.initializedCollapsed || _this2.props.matches
    };
    return _this2;
  }

  _createClass(SideNavP, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.props.onClick(this.props.initializedCollapsed || this.props.matches);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var resizePage = R.not(R.equals(this.props.matches, nextProps.matches));

      if (resizePage) {
        this.setState({
          sideNavPreviousState: nextProps.collapsed
        });
        var resizeVar = !nextProps.matches && this.state.sideNavPreviousState ? nextProps.collapsed : nextProps.matches;
        this.props.onClick(resizeVar);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          appName = _this$props.appName,
          onClick = _this$props.onClick,
          collapsed = _this$props.collapsed,
          children = _this$props.children,
          userMenu = _this$props.userMenu,
          homeLink = _this$props.homeLink,
          restProps = _objectWithoutProperties(_this$props, ["appName", "onClick", "collapsed", "children", "userMenu", "homeLink"]);

      var restPropsForDOMElements = R.omit(['initializedCollapsed', 'logoBackground', 'toggleSideNav', 'matches'], restProps);

      var toggle = function toggle() {
        return onClick(!collapsed);
      };

      var capAppName = appName ? appName.toUpperCase() : '';
      var userMenuWithColor = userMenu ? _react.default.cloneElement(userMenu, {
        color: '#49c5b1'
      }) : null;
      return _react.default.createElement("ul", _extends({}, restPropsForDOMElements, {
        className: 'vs-sidenav' + (collapsed ? ' collapsed' : ' active')
      }), _react.default.createElement("li", {
        className: "vs-sideNav-left-logo"
      }, _react.default.createElement("a", {
        href: "".concat(homeLink ? homeLink : '/'),
        className: "vs-sidenav-container-row"
      }, _react.default.createElement("div", {
        className: "vs-logo"
      }, this.props.logo), _react.default.createElement("span", {
        className: "vs-app-name"
      }, capAppName))), children, userMenuWithColor, _react.default.createElement("li", {
        className: "vs-toggle-icon"
      }, _react.default.createElement(_Icons.ToggleIcon, {
        onClick: toggle,
        sideNavState: collapsed
      })));
    }
  }]);

  return SideNavP;
}(_react.default.Component);

SideNav.propTypes = {
  active: _propTypes.default.bool
};